module.exports = __webpack_public_path__ + "img/refresh-green.63aae4af.svg";